import * as React from 'react';
import FlightInfoComponent from '@websky/core/src/DesktopFlightRoute/components/Segment/FlightInfo/FlightInfo';
const FlightInfo = props => {
    return React.createElement(FlightInfoComponent, Object.assign({}, props));
};
export default FlightInfo;
